<template>
<div class="chapter">
<div class="inner_page">
<p class="p8">Para todos los trabajadores de CPRW; estoy muy agradecido de haberlos conocido.</p>
<p class="p0"> </p>
<p class="p0">Para Dominic, el amor de mi vida,</p>
<p class="p0">sin cuyo apoyo no hubiese podido hacer nada de esto.</p>
<p class="p0"> </p>
<p class="p0">Y para todo el personal de Dreamspinner Press,</p>
<p class="p0">por todo lo que hacéis para que mis novelas luzcan bien.</p>
<p class="p0">Sois los mejores.</p>
<p class="p9"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?85422f5e